export const StatusKey = {
  CREATED: 0,
  PICKED_UP: 1,
  WASHED: 2,
  DELIVERED: 3,
  FOLDED: 4,
};

export const AbsenceStatusKey = {
  NOT_ABSENT: 0,
  PICKUP_ABSENT: 1,
  DELIVERY_ABSENT: 2,
  PEND: 3,
};

export const DeliveryType = {
  NEXT_DAY: 1,
  TWO_DAYS_LATER: 2,
  SAME_DAY: 3,
};
